/* eslint-disable no-plusplus */
import React, { useState } from 'react';

import WelcomeLetter from './WelcomeLetter';
import Statement from './Statement';
import PaymentHistoryStatement from './PaymentHistoryStatement';
import FormContainer from '../../../FormContainer';
import ImpoundStatement from './ImpoundStatement';
import AccelerationPackage from './AccelerationPackage';

import ReportService from '../../../../../services/ReportService';
import { useUiContext } from '../../../../../context/UiContext';
import downloadDocument from '../../../../../helpers/downloadDocument';
import usePayoffLetterForm from '../../../../../forms/loan/payoffLetter';
import useUserRole from '../../../../../hooks/useUserRole';

export default function Actions({ loanId, loan, refetchLoan }) {
  const [isFetching, setIsFetching] = useState(false);

  const { showToast } = useUiContext();

  const { isLender } = useUserRole();

  const downloadPayoffLetter = async (formValues, actions) => {
    setIsFetching(true);

    const values = {};

    // Remove empty values
    Object.entries(formValues).forEach(([key, value]) => {
      if (value) {
        values[key] = value;
      }
    });

    delete values.created_at;

    try {
      const response = await ReportService.getPayoffLetter({
        loanId,
        formValues: values,
      });

      downloadDocument(response.id, 'payoff_letter.pdf');
      actions.resetForm();
      refetchLoan();
    } catch (err) {
      console.log('error', err);
      showToast({
        text: err?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    } finally {
      setIsFetching(false);
    }
  };

  const payoffLetterForm = usePayoffLetterForm(downloadPayoffLetter, {
    ...(loan?.payoff_statements?.at(-1) ?? {}),
    _lien_holder: loan?._lien_holder,
  });

  return (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10 overflow-visible">
      {!isLender && (
        <>
          <div className="mb-10">
            <FormContainer
              form={payoffLetterForm}
              noBillComId
              isSubmitting={isFetching}
            />
          </div>
          <hr className="mb-10" />
          <WelcomeLetter loan={loan} refetchLoan={refetchLoan} />
          <hr className="mb-10 mt-10" />
          <div>
            <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6">
              Mail Statement
            </h2>
            <Statement loanId={loanId} />
          </div>
          <hr className="mb-10 mt-10" />
          <div>
            <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6">
              Payment History Statement
            </h2>
            <PaymentHistoryStatement loanId={loanId} />
          </div>
          <hr className="mb-10 mt-10" />
          <div>
            <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6">
              Impound Statement
            </h2>
            <ImpoundStatement loanId={loanId} />
          </div>
          <hr className="mb-10 mt-10" />{' '}
          <div>
            <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6">
              Acceleration Package
            </h2>
            <AccelerationPackage loanId={loanId} />
          </div>
        </>
      )}
    </div>
  );
}
